import { Component, ViewEncapsulation } from '@angular/core';
import { PosthogService } from './providers/posthog.service';


export class AppComponent {
	constructor(private analyticsService: PosthogService) {}
static ctorParameters() { return [ { type: PosthogService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.component.ts